import { NOTE_PLACES } from '@ehr/shared';
import { US_STATES } from '../lib/noteBilling.js';
import { Dd } from './Dropdown.js';

type Place = (typeof NOTE_PLACES)[number];

/**
 * ehr#724 (ADMIN_PHONE_NOTE_10-30-V7, V3 12a): Session details' Type and place row opened, on an
 * Admin / phone note. The kind as a read-only Session type box, then Where (and the client's state
 * on a telehealth or phone contact, as on every note). Nothing about billing: no Linked plan,
 * Billing code, Diagnosis, Billing line or interactive complexity.
 */
export function AdminTypePlace({
  kind,
  place,
  onPlace,
  locState,
  onLocState,
  clientAt,
  onClientAt,
  disabled,
}: {
  kind: string;
  place: Place;
  onPlace: (p: Place) => void;
  locState: string;
  onLocState: (s: string) => void;
  clientAt: 'Home' | 'Other';
  onClientAt: (c: 'Home' | 'Other') => void;
  disabled: boolean;
}) {
  return (
    <div className="pn-sx-body" id="pn-sx-body" data-test="admin-type-place">
      <div className="pn-sx-grid">
        <div className="pn-sd-f">
          <span>Session type</span>
          <div className="pn-sd-dur" data-test="note-type" aria-label="Session type">
            {kind}
          </div>
        </div>
        <div className="pn-sd-f">
          <span>Where</span>
          <div className="pn-seg pn-seg-full" role="group" aria-label="Where">
            {NOTE_PLACES.map((pl) => (
              <button
                key={pl}
                type="button"
                aria-pressed={place === pl}
                disabled={disabled}
                onClick={() => onPlace(pl)}
              >
                {pl}
              </button>
            ))}
          </div>
        </div>
      </div>
      {place !== 'In person' && (
        <div className="pn-sx-grid">
          <div className="pn-sd-f">
            <span>Client location (state)</span>
            <Dd
              value={locState}
              placeholder="Select state"
              ariaLabel="Client location (state)"
              onChange={onLocState}
              options={US_STATES.map((s) => ({ value: s, label: s }))}
              disabled={disabled}
            />
          </div>
          <div className="pn-sd-f">
            <span>Client is at</span>
            <div className="pn-seg pn-seg-full" role="group" aria-label="Client is at">
              {(['Home', 'Other'] as const).map((o) => (
                <button
                  key={o}
                  type="button"
                  aria-pressed={clientAt === o}
                  disabled={disabled}
                  onClick={() => onClientAt(o)}
                >
                  {o}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
